<template>
    <div id="content" class="areaMicroContent">
        <div class="microClassList">
            <!-- <Tabs type="card" @on-click="choseTab" :value="tabType">
                <TabPane label="全国资源" name="1"></TabPane>
                <TabPane label="区域资源" name="2"></TabPane>
                <TabPane label="校本资源" name="3" ></TabPane>
                <TabPane label="我的资源" name="4"  v-if="userType != 'student'"></TabPane>
            </Tabs> -->
            <div class="areaTabBox">
                <!-- <div :class="tab1?'tabItem xuet tabActive':'tabItem xuet'" @click="choseTab(1)">学堂资源</div> -->
                <div :class="tab1?'tabItem tabActive':'tabItem'" @click="choseTab(1)">全国资源</div>
                <div :class="tab2?'tabItem tabActive':'tabItem'" @click="choseTab(2)">区域资源</div>
                <div :class="tab3?'tabItem tabActive':'tabItem'" @click="choseTab(3)">校本资源</div>
                <div :class="tab4?'tabItem tabActive':'tabItem'" @click="choseTab(4)">我的资源</div>
            </div>
            <div class="uploadBox" style="margin-bottom:20px;">
                <div class="material">共{{pageTotal}}份资源</div>
                <div class="upload" @click="upLoad" v-show="tabType == 4" v-if="userType != 'student'">
                    <img src="/static/images/upload.png" alt="">上传资源
                </div>
            </div>
            <!-- 数据为空时显示 组件 -->
            <empty v-if="isEmpty" :noLogin="noLogin"></empty>
             <Row class="rowList" :gutter="27" v-else v-for="(item,index) in microList" :key="index" style="margin-bottom:15px;">
                <Col span="6" v-for="(n,m) in item" :key="m">
                    <div class="microBox" @click="videoPlayer(n.videoId,n.name,3,n.id)">
                        <div class="microImgBoxs" :ref="'ImgBoxWidth'+ m" :style="{'height':documentHeight}">
                            <img class="microImg" :src="n.imgurl==null?videoBg:n.imgurl" alt="">
                            <div class="mengBox">
                                <img src="/static/images/mengImg.png" alt="" class="meng">
                            </div>
                        </div>
                        <div class="microMsg">
                            <div class="microTitle" :title="n.name">{{n.name}}</div>
                        </div>
                    </div>
                </Col>
            </Row>
        </div>
        <div class="page" v-if="pageTotal > 12" v-show="!isEmpty">
             <Page :total="pageTotal" :page-size="12" @on-change="changePage"/>
        </div>
        <message v-show="isShowMessage" :msg="msg" @isShowMsg="isShowMsg" :isShowMessage="isShowMessage"></message>
    </div>
</template>
<script>
import api from '../../utils/api.js';
import bus from '../../assets/eventBus/enentBus.js';
import cookie from '../../assets/getCookie.js';
import message from '../Message/Message.vue'
import empty from '../Empty/Empty.vue'
export default {
    name:'MicroClassList',
    data(){
        return{
            urlHttp:'/testIp',
            microList:null,                                         //微课列表  array
            imgurl:'https://www.aixuetang.com/pic',              //微课图片地址  线上域名
            microNum:null,                                          // 微课数量
            pageTotal:null,                                         //总页数
            gradeId:null,                                           //年级id  通过筛选按钮传过来
            versionId:null,                                         //版本id  通过筛选按钮传过来
            subjectId:null,                                         //学科id  通过筛选按钮传过来
            tabType:'1',
            shareSchoolId:null,
            teacherId:null,
            userType:null,
            msg:null,
            isShowMessage:false,
            videoBg:'/static/images/videobg.png',
            isEmpty:false,
            subjectIdLong:null,
            gradeIdLong:null,
            knowledgeId:null,
            documentHeight:null,
            tab1:true,
            tab2:false,
            tab3:false,
            tab4:false,
            noLogin:null
        }
    },
    mounted(){
        const that = this;
        this.getAreaData(1,that.gradeId,that.subjectId,that.versionId,this.knowledgeId);
        bus.$off('areaGradeId')
        bus.$on('areaGradeId',function(msg){
            //console.log('年级',msg)
            that.gradeId = msg;

        })
        bus.$off('areaGradeIdLong')
        bus.$on('areaGradeIdLong',function(msg){
            //console.log('长年级',msg)
            that.gradeIdLong = msg;
            that.getAreaData(1,msg,that.subjectIdLong,that.versionId,that.knowledgeId);
        })
        bus.$off('areaSubjectId')
        bus.$on('areaSubjectId',function(msg){
            that.subjectId = msg;
        })
        bus.$off('areaSubjectIdLong')
        bus.$on('areaSubjectIdLong',function(msg){
            //console.log('长学科',msg)
            that.subjectIdLong = msg;
            that.getAreaData(1,that.gradeIdLong,msg,that.versionId,that.knowledgeId);
        })
        bus.$off('areaVersionId')
        bus.$on('areaVersionId',function(msg){
            that.versionId = msg;
            that.getAreaData(1,that.gradeIdLong,that.subjectIdLong,msg,that.knowledgeId);
        })
        bus.$off('materialId')
        bus.$on('materialId',function(msg){
            that.knowledgeId = msg;
            that.getAreaData(1,that.gradeIdLong,that.subjectIdLong,that.versionId,msg);
        })
        this.websiteId = localStorage.getItem('websiteId');
        const cookie_token = cookie.getCookie('AXY_'+ this.websiteId +'_access_token')
        if(cookie_token){
            if(cookie_token != 'null'){
                // console.log('以登录')
                 this.isShowDownloadBtn = true;
                this.shareSchoolId = localStorage.getItem('schoolId');
                this.teacherId = localStorage.getItem('userId');
                this.userType = localStorage.getItem('userType')
            }
        }else{
            // console.log('未登录')
             this.isShowDownloadBtn = false;
            this.shareSchoolId = null;
            this.teacherId = null;
        }
    },
    updated(){
        console.log(this.$refs.ImgBoxWidth0)
        this.$nextTick(()=>{
          this.documentHeight = this.$refs.ImgBoxWidth0[0].clientWidth*9/16+'px'
        })
        
    },
    methods:{
        //获取微课列表
        getAreaData(pageNo,gradeIds,subjectId,versionId,knowledgeId){
            this.isEmpty = false;
            const that = this;
            const result = [];
            const url =  '/axt-data/dataVideo/pageDataVideo/?orderBys%5B0%5D.field=createTime&orderBys%5B0%5D.direction=desc';
            if(this.tabType == '1'){
                var params = {
                    pageSize:12,
                    pageNo:pageNo,
                    gradeId:gradeIds,
                    subjectId:subjectId,
                    versionId:versionId,
                    knowledgeId:knowledgeId,
                    shareNetId:1
                }
            }
            if(this.tabType == '2'){
                var params = {
                    pageSize:12,
                    pageNo:pageNo,
                    gradeId:gradeIds,
                    subjectId:subjectId,
                    versionId:versionId,
                    knowledgeId:knowledgeId,
                    shareWebsiteId: this.websiteId
                }
            }
            if(this.tabType == '3'){
                var params = {
                    pageSize:12,
                    pageNo:pageNo,
                    gradeId:gradeIds,
                    subjectId:subjectId,
                    versionId:versionId,
                    knowledgeId:knowledgeId,
                    shareSchoolId: this.shareSchoolId
                }
            }
            if(this.tabType == '4'){
                var params = {
                    pageSize:12,
                    pageNo:pageNo,
                    gradeId:gradeIds,
                    subjectId:subjectId,
                    versionId:versionId,
                    knowledgeId:knowledgeId,
                    teacherId: this.teacherId
                }
            }
            //console.log(params,'params’')
            api.getListAPI(url,params).then(res => {
                console.log('优质课',res)
                if(res.data.message == 'success'){
                    if(res.data.data.total != 0  && res.data.data != null){
                        that.microNum = res.data.data.total;                        //微课总数量
                        that.pageTotal = res.data.data.total;                   //分页总数
                        const microList = res.data.data.rows
                        for(let i=0;i < microList.length;i+=4){
                            result.push(microList.slice(i,i+4));
                        }
                        that.microList = result;
                        that.isEmpty = false;
                    }else{
                        that.isEmpty = true;
                        that.noLogin = '暂时没有相关内容～';
                        that.microList = [];
                        that.pageTotal = 0;
                    }

                }
            })
        },
        choseTab(name){
            this.tabType = name;
            if(name == 1){
                this.tab1 = true;
                this.tab2 = false;
                this.tab3 = false;
                this.tab4 = false;
            }
            if(name == 2){
                this.tab1 = false;
                this.tab2 = true;
                this.tab3 = false;
                this.tab4 = false;
            }
            if(name == 3){
                if(this.shareSchoolId == null || this.shareSchoolId == undefined){
                    this.microList = [];
                    this.isEmpty = true;
                    this.noLogin = '您尚未登录哦！'
                    this.isShowMessage = true;
                    this.msg = ('您尚未登录');
                    this.tabType = number;
                    return false
                }
                this.tab1 = false;
                this.tab2 = false;
                this.tab3 = true;
                this.tab4 = false;
            }
            if(name == 4){
                if(this.shareSchoolId == null || this.shareSchoolId == undefined){
                    this.microList = [];
                    this.isEmpty = true;
                    this.noLogin = '您尚未登录哦！'
                    this.isShowMessage = true;
                    this.msg = ('您尚未登录');
                    return
                }
                this.tab1 = false;
                this.tab2 = false;
                this.tab3 = false;
                this.tab4 = true;
            }
            this.getAreaData(1,this.gradeIdLong,this.subjectIdLong,this.versionId,this.knowledgeId);
        },

        //翻页
        changePage(page){
            const that = this;
            this.getAreaData(page,this.gradeIdLong,this.subjectIdLong,this.versionId,this.knowledgeId);

        },
        //点击播放
        videoPlayer(videoId,name,sourse,id){
          if(this.shareSchoolId == null || this.shareSchoolId == undefined){
                this.isShowMessage = true;
                this.msg = ('您尚未登录');
                this.tabType = number;
                return
            }
            this.$emit('showPlayer',true)
             const vidoeData = {
                videoId:videoId,
                name:name,
                sourse:sourse,
                id:id
            }
            this.$nextTick(() => {
                bus.$emit('videoId',vidoeData)
            })

        },
        isShowMsg(msg){
            this.isShowMessage = false;
        },
        upLoad(){
          this.$emit('isUpload',true)
          // bus.$emit('upLoadKnowledgeId',this.knowledgeId);
          // bus.$emit('upLoadStylelId',this.stylelId);
          // bus.$emit('upLoadGradeId',this.gradeId);
          // bus.$emit('upLoadSubjectId',this.subjectId);
          // bus.$emit('upLoadGradeIdLong',this.gradeIdLong);
          // bus.$emit('upLoadSubjectIdLong',this.subjectIdLong);
          // bus.$emit('upLoadVersionId',this.versionId);

          const data = {
              'upLoadKnowledgeId':this.knowledgeId,
              'upLoadStylelId':this.stylelId,
              'upLoadGradeId':this.gradeId,
              'upLoadSubjectId':this.subjectId,
              'upLoadGradeIdLong':this.gradeIdLong,
              'upLoadSubjectIdLong':this.subjectIdLong,
              'upLoadVersionId':this.versionId
          }
          this.$emit('upLoadData',data)
        }
    },
    components:{message,empty}
}
</script>
<style lang="" scoped>
  .emptyImg {
    width: 320px;
  }
    .areaMicroContent{
        margin-top: 27px!important;
         border-top: solid 2px #3583FF;
        border-bottom: 1px solid #DADADA;
        border-right: 1px solid #DADADA;
        border-left: 1px solid #DADADA;
        min-height: 600px;
    }
    .microClassNum{
        text-align: left;
        color: #9A9A9A;
        font-size: 14px;
        margin-bottom: 20px;
    }
    .microBox:hover{
        cursor: pointer;
    }
    .microBox:hover .microImg{
        animation: ImgHover .3s forwards;
    }
     @keyframes ImgHover{
        form{margin-top: 0;box-shadow: 0px 0px 17px 0px rgba(255,255,255,0);}
        to{margin-top:-5px;box-shadow: 0px 0px 17px 0px rgba(133, 137, 160, 0.37);}
    }
    .microBox:hover .microTitle{
        color:#3683FF;
    }
    .microImgBoxs{
        /* height:200px; */
        display: block!important;
    }
    .microImg{
        width:100%;
        height: 100%;
        border-radius: 10px;
    }
    .microImgHover{
        display: inline-block;
        border-radius: 10px;
    }

    .microMsg{
        margin: 15px 0 20px;
    }
    .microTitle{
        font-size: 20px;
        color: #34495E;
        font-weight: 500;
        text-align: left;
        padding-left: 17px;
    }
/* 上传 */
    .uploadBox{
        width:96%;
        overflow: hidden;
        /* margin-bottom: 20px; */
        margin-left: 2%;
        margin-top: 29px;
    }
    .uploadBox .material{
        float:left;
        font-size: 14px;
        color: #9A9A9A;
    }
    .uploadBox .upload{
        display: table-cell;
        vertical-align: middle;
        font-size: 14px;
        color: #F95F30;
        float: right;
    }
    .uploadBox .upload:hover{
        cursor: pointer;
    }
    .uploadBox .upload img{
        width:16px;
        height: 14px;
        display: inline-block;
    }
    .rowList{
        width:98%;
        margin: 0 auto!important;
    }
     /* 蒙版 */
    .microImgBoxs{
        position: relative;
    }
    .mengBox{
        width:100%;
        height: 100%;
        position: absolute;
        left: 0;
        top:0;
        z-index: 10;
        background:rgba(255, 255, 255, 0);
        border-radius: 10px;
    }
    .mengBox img{
        position: absolute;
        left: 50%;
        top: 50%;
        /* transform: translate(-50%,-50%); */
        margin-left: -33px;
        margin-top: -33px;
        opacity: 0;
    }
    .microBox:hover .mengBox{
        animation: mengHovar .3s forwards;
    }
    .microBox:hover .mengBox img{
        animation: mengImgHovar .3s forwards;
    }
    @keyframes mengHovar{
        from {top:0;background: rgba(255, 255, 255, 0);}
        to {top:-5px;background: rgba(0, 0, 0, 0.3);}
    }
    @keyframes mengImgHovar{
        from {opacity: 0;transform: scale(2);}
        to {opacity: 1;transform: scale(1);}
    }
</style>



// WEBPACK FOOTER //
// src/components/MicroClassList/areaQualityCourseList.vue